// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LWBn","footer":"styles_footer__9qtfX"};